import { createContext, useState } from "react";
const UserContext = createContext();
import { useMain } from "../state/userMainState";
import { useCheckAPI } from "../hooks/useCheckAPI";

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({
    userName: "",
    name: "",
    custName: "",
    companyContactNo: "",
    email: "",
    staffID: "",
    poNumberFormat: "",
    contractNoFormat: "",
    allowcheckout: "",
    overEntitlementAction: "No Action",
    userType: "",
  });

  const { isSuccess, data, isPending, isError, error } = useMain();

  // Success Function
  const successFunc = () => {
    const user = data?.data?.data?.data?.data?.user;
    if (!user) return;
    const userData = {
      userName: user.userName,
      name: user.name,
      custName: user.custName,
      companyContactNo: user.companyContactNo,
      email: user.email,
      staffID: user.staffID,
      poNumberFormat: user.poNumberFormat,
      contractNoFormat: user.contractNoFormat,
      allowcheckout: user.allowcheckout,
      overEntitlementAction: user.overEntitlementAction || "No Action",
      userType: user.userType || "",
    };
    setUser(userData);
  };

  // Error Function
  const errorFunc = () =>
    console.warn(`Error: ${data.data.status}: ${data.data.statusText}`);

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <UserContext.Provider value={{ user }}>{children}</UserContext.Provider>
  );
};

export default UserContext;
